import { infoSheetConstants } from '../constants/infoSheetConstants';

const initialState = {
  infoSheet: {
    status: null,
  },
};

export default function infoSheet(state = initialState, action) {
  switch (action.type) {
    case infoSheetConstants.LOAD_INFOSHEET_REQUEST:
      return {
        ...state,
        requestingLoading: true,
        loaded: false,
      };
    case infoSheetConstants.LOAD_INFOSHEET_SUCCESS:
      return {
        ...state,
        requestingLoading: false,
        infoSheet: action.infoSheet,
        loaded: true,
      };
    case infoSheetConstants.LOAD_INFOSHEET_FAILURE:
      return {
        ...state,
        requestingLoading: false,
        loaded: false,
      };
    case infoSheetConstants.SEND_INFOSHEET_REQUEST:
      return {
        ...state,
        requestingSend: true,
        sent: false,
      };
    case infoSheetConstants.SEND_INFOSHEET_SUCCESS:
      return {
        ...state,
        requestingSend: false,
        sent: true,
        infoSheet: action.infoSheet,
      };
    case infoSheetConstants.SEND_INFOSHEET_FAILURE:
      return {
        ...state,
        requestingSend: false,
        sent: false,
      };
    case infoSheetConstants.UPDATE_INFOSHEET_REQUEST:
      return {
        ...state,
        requestingUpdate: true,
        updated: false,
      };
    case infoSheetConstants.UPDATE_INFOSHEET_SUCCESS:
      return {
        ...state,
        requestingUpdate: false,
        updated: true,
        infoSheet: action.infoSheet,
      };
    case infoSheetConstants.UPDATE_INFOSHEET_FAILURE:
      return {
        ...state,
        requestingUpdate: false,
        updated: false,
      };
    default:
      return state;
  }
}
